import React from "react";
import { TeachersUIProvider } from "./TeachersUIContext";
import { TeachersCard } from "./TeachersCard";

export function TeachersPage({ history }) {
  const teachersUIEvents = {
    openNewTeacherPage: () => {
      history.push("/ogretmenler/ekle");
    },
    openEditTeacherPage: (id) => {
      history.push(`/ogretmenler/duzenle/${id}`);
    },
  };
  
  return (
    <TeachersUIProvider teachersUIEvents={teachersUIEvents}>
      <TeachersCard />
    </TeachersUIProvider>
 );
}